import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Business Description")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Business Name", -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Summary (Brief & clear description shared with investors)", -1)
const _hoisted_7 = { class: "float-end my-1" }
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Overview (Mission statement & vision)", -1)
const _hoisted_10 = { class: "float-end my-1" }
const _hoisted_11 = { class: "fv-row mb-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Defensible USP", -1)
const _hoisted_13 = { class: "float-end my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        onBlur: _ctx.createDraft,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fieldChanged($event))),
        type: "textarea",
        name: "name",
        class: "form-control form-control-lg form-control-solid",
        rows: "10",
        modelValue: _ctx.businessName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.businessName) = $event))
      }, null, 8, ["onBlur", "modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "name",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        maxlength: "200",
        onBlur: _ctx.createDraft,
        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.limitInput($event))),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fieldChanged($event))),
        type: "text",
        modelValue: _ctx.summary,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.summary) = $event)),
        as: "textarea",
        class: "form-control form-control-lg form-control-solid",
        name: "summary",
        placeholder: ""
      }, null, 8, ["onBlur", "modelValue"]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.summary?.length) + "/" + _toDisplayString(_ctx.limitLength), 1),
      _createVNode(_component_ErrorMessage, {
        name: "summary",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_Field, {
        maxlength: "200",
        onBlur: _ctx.createDraft,
        onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.limitInput($event))),
        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fieldChanged($event))),
        modelValue: _ctx.overview,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.overview) = $event)),
        type: "text",
        as: "textarea",
        class: "form-control form-control-lg form-control-solid",
        name: "overview",
        placeholder: "",
        value: _ctx.formData?.overview ?? ''
      }, null, 8, ["onBlur", "modelValue", "value"]),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.overview?.length) + "/" + _toDisplayString(_ctx.limitLength), 1),
      _createVNode(_component_ErrorMessage, {
        name: "overview",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode(_component_Field, {
        maxlength: "200",
        onBlur: _ctx.createDraft,
        onKeypress: _cache[8] || (_cache[8] = ($event: any) => (_ctx.limitInput($event))),
        onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fieldChanged($event))),
        type: "text",
        modelValue: _ctx.defensibleUsp,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.defensibleUsp) = $event)),
        as: "textarea",
        class: "form-control form-control-lg form-control-solid",
        name: "defensibleUsp",
        placeholder: "",
        value: _ctx.formData?.defensibleUsp ?? ''
      }, null, 8, ["onBlur", "modelValue", "value"]),
      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.defensibleUsp?.length) + "/" + _toDisplayString(_ctx.limitLength), 1),
      _createVNode(_component_ErrorMessage, {
        name: "defensibleUsp",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}